import { render, staticRenderFns } from "./71.vue?vue&type=template&id=c0f027f2&scoped=true&"
var script = {}
import style0 from "./71.vue?vue&type=style&index=0&id=c0f027f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f027f2",
  null
  
)

export default component.exports